import { Container } from "@mantine/core";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import MainContainer from "../../components/MainContainer";
import Nav from "../../components/Navbar";
import Facility from "./Facility";
import FacilityType from "./FacilityType";
import Note from "./Note";
import Patient from "./Patient";
import Reports from "./Report";
import Setting from "./Setting";
import Notification from "./Notificaton";
import Staff from "./Staff";
import Task from "./Task";
import TaskType from "./Task/TaskType.jsx";
import AddTask from "./Task/AddTask.jsx";
import useStyles from "./style";
import { isSubscriptionExpired } from "../../utils";
import { useEffect, useState } from "react";
import Medication from "./Medication";
import SupportPlan from "./SupportPlan";
import SingleTicket from "../SingleTicket/index.jsx";
import HaveProblem from "../HaveProblem/index.jsx";
import ViewTask from "./Task/ViewTask.jsx";
import EditTask from "./Task/EditTask.jsx";
import Client from "./Client/index.jsx";
import NewDashboard from "./Dashboard/NewDashboard.jsx";
import NewNoteType from "./NoteType/NewNoteType.jsx";
import Billing from "./Billling/index.jsx";
import BillingClaimForm from "./BillingClaimForm/index.js";
import BillingInvoices from "./BillingInvoices/index.js";
import StaffDetails from "./Staff/StaffDetails.jsx";
import { StaffAttendance } from "./Staff/StaffAttendance.jsx";
import FacilityDetails from "./Facility/FacilityDetails.jsx";

const Home = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  let token = Cookies.get("token");
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const billing = useSelector((state) => state.featureFlags.billing);
  
  useEffect(() => {
    const isExpired = isSubscriptionExpired();
    if (isExpired) {
      if (profile?.user?.type === "staff") return navigate("/home/settings");
      navigate("/home/settings?selectedTab=upgrade");
    }
  }, [profile?.subscription?.expiredAt]);

  useEffect(() => {
    const isActivated = profile?.signature?.length === 0;
    if (isActivated) {
      if (profile?.user?.type === "staff");
      navigate("/home/settings?selectedTab=my-signature");
    }
  }, [profile?.signature]);

  if (token && !profile?.business && profile?.user?.type !== "staff")
    return <Navigate to="/signup" state={{ token: token }} />;

  const PermissionProtectedRoute = ({ permissionKey, children }) => {
    const permissions = profile?.user?.permissions;
    
    if (!profile?.user?.role && !profile?.user?.type) {
      return children;
    }

    if (!permissions || !permissions[permissionKey]) {
      return children;
    }
    // if (!permissions || typeof permissions !== "object") {
    //   return children;
    // }
    
    if (permissions[permissionKey] === true) {
      return children;
    }

    return <Navigate to="/home/dashboard" replace />;
  };

  if (!token) return <Navigate to="/login" />;

  // if (signatureLoading) return <div>Loading...</div>;

  return (
    <MainContainer isSidebarOpen={isSidebarOpen}>
      <Container className={classes.wrapper} fluid p={0}>
        <Nav
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Routes>
          <Route
            index
            element={<NewDashboard isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="dashboard"
            element={<NewDashboard isSidebarOpen={isSidebarOpen} />}
          />
          <Route path="supportPlan" element={<SupportPlan />} />
          <Route
            path="facility"
            element={
              <PermissionProtectedRoute permissionKey="facility">
                <Facility />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="facility/:id/:mode"
            element={
              <PermissionProtectedRoute permissionKey="facility">
                <FacilityDetails />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="staff"
            element={
              <PermissionProtectedRoute permissionKey="staff">
                <Staff />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="staff/:id/:mode"
            element={
              <PermissionProtectedRoute permissionKey="staff">
                <StaffDetails />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="staff/manage-attendance/:id"
            element={
              <PermissionProtectedRoute permissionKey="staff">
                <StaffAttendance />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="facilitytype"
            element={
              <PermissionProtectedRoute permissionKey="facility">
                <FacilityType />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="report"
            element={
              <PermissionProtectedRoute permissionKey="report">
                <Reports />
              </PermissionProtectedRoute>
            }
          />
          <Route path="client" element={<Client />} />
          <Route path="patient" element={<Patient />} />
          <Route
            path="medication"
            element={
              <PermissionProtectedRoute permissionKey="medication">
                <Medication />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="note"
            element={
              <PermissionProtectedRoute permissionKey="note">
                <Note />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="notetype"
            element={
              <PermissionProtectedRoute permissionKey="note">
                <NewNoteType />
              </PermissionProtectedRoute>
            }
          />
          <Route path="settings" element={<Setting />} />
          <Route path="notifications" element={<Notification />} />
          <Route
            path="tasks"
            element={
              <PermissionProtectedRoute permissionKey="task">
                <Task />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="taskType"
            element={
              <PermissionProtectedRoute permissionKey="task">
                <TaskType />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="add-task"
            element={
              <PermissionProtectedRoute permissionKey="task">
                <AddTask />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="view-task"
            element={
              <PermissionProtectedRoute permissionKey="task">
                <ViewTask />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="edit-task"
            element={
              <PermissionProtectedRoute permissionKey="task">
                <EditTask />
              </PermissionProtectedRoute>
            }
          />
          <Route path="ticket/:id" element={<SingleTicket />} />
          <Route path="create-ticket" element={<HaveProblem />} />
          {billing && (
            <>
              <Route
                path="billing"
                element={
                  <PermissionProtectedRoute permissionKey="billing">
                    <Billing />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="billing-claim-form"
                element={
                  <PermissionProtectedRoute permissionKey="billing">
                    <BillingClaimForm />
                  </PermissionProtectedRoute>
                }
              />
            </>
          )}
          <Route
            path="invoices"
            element={
              <PermissionProtectedRoute permissionKey="invoice">
                <BillingInvoices />
              </PermissionProtectedRoute>
            }
          />
        </Routes>
      </Container>
    </MainContainer>
  );
};
export default Home;
